import { api } from '../lib/api';

const notificationService = {
  async list({ page = 1, limit = 20, is_read, type } = {}) {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (typeof is_read !== 'undefined') params.set('is_read', String(!!is_read));
    if (type) params.set('type', String(type));
    const res = await api.get(`/notifications?${params.toString()}`);
    const d = res?.data || res;
    const list = d?.data?.notifications || d?.notifications || d?.data || [];
    return Array.isArray(list) ? list : [];
  },
  async getUnreadCount() {
    try {
      const list = await this.list({ is_read: false, limit: 1 });
      const res = await api.get('/notifications?is_read=false&limit=1');
      const d = res?.data || res;
      const meta = d?.meta || d?.data?.meta || {};
      const total = Number(meta?.total || 0);
      if (Number.isFinite(total) && total >= 0) return total;
      return Array.isArray(list) ? list.length : 0;
    } catch {
      return 0;
    }
  },
  async markRead(id) {
    if (!id) return { ok: false };
    const res = await api.patch(`/notifications/${id}/read`);
    return res?.data?.data?.notification || res?.data?.notification || res?.data;
  },
  async markAllRead({ type } = {}) {
    const res = await api.post(`/notifications/mark-all-read`, type ? { type } : {});
    const d = res?.data || res;
    const remaining = d?.data?.remaining_unread;
    return Number.isFinite(remaining) ? remaining : null;
  },
  async deleteRead() {
    const res = await api.delete('/notifications/read');
    const d = res?.data || res;
    const removed = d?.data?.removed || d?.removed;
    return Number.isFinite(Number(removed)) ? Number(removed) : true;
  },
  async delete(id) {
    if (!id) return { ok: false };
    const res = await api.delete(`/notifications/${id}`);
    return res?.data || res;
  },
  async getStats({ sampleLimit = 100 } = {}) {
    try {
      // First, get all notifications without is_read filter to get total and types
      const res = await api.get(`/notifications?limit=${sampleLimit}`);
      const d = res?.data || res;
      const list = d?.data?.notifications || d?.notifications || d?.data || [];
      const items = Array.isArray(list) ? list : [];
      const meta = d?.meta || d?.data?.meta || {};
      
      // Use exact count from API if available, otherwise use items length
      const total = Number(meta?.total) || items.length;
      const unread = items.filter((n) => !n.is_read).length;
      const byType = items.reduce((acc, n) => {
        const t = n.type || 'other';
        acc[t] = (acc[t] || 0) + 1;
        return acc;
      }, {});
      
      // If we have exact counts, also get unread count separately
      let exactUnread = unread;
      if (meta?.total) {
        try {
          const unreadRes = await api.get('/notifications?is_read=false&limit=1');
          const unreadD = unreadRes?.data || unreadRes;
          const unreadMeta = unreadD?.meta || unreadD?.data?.meta || {};
          exactUnread = Number(unreadMeta?.total) ?? unread;
        } catch { 
          // Fallback to sampled count
        }
      }
      
      return { total, unread: exactUnread, byType };
    } catch {
      return { total: 0, unread: 0, byType: {} };
    }
  },
};

export default notificationService;
